angular.module('myConsultApp').factory('CmsService', ($resource, ENV, Session) => {
  var title = '';
  var subtitle = '';
  var body = '';
  var cmsService = {};
  cmsService.getDashboardTile = () => {
    var cms = $resource(
      ENV.apiEndpoint + '/1.0/cms/pro-rewards-dashboard-messages/',
      {},
      {
        get: {
          headers: { Authorization: 'Bearer ' + Session.accessToken },
        },
      },
    );

    return cms.get().$promise.then((response) => {
      return response.cms;
    });
  };

  cmsService.getCmsContent = (slug) => {
    var cms = $resource(
      ENV.apiEndpoint + '/1.0/cms/' + slug + '/',
      {},
      {
        get: {
          headers: { Authorization: 'Bearer ' + Session.accessToken },
        },
      },
    );

    return cms.get().$promise.then((response) => {
      if (response) {
        return response.cms;
      }
    });
  };

  cmsService.getBlogArticles = () => {
    var cms = $resource(
      ENV.contentStackProxyUrl + '/cms/2.0/blog/articles?rows=6',
      {},
      {
        get: {
          withCredentials: false,
          headers: {},
        },
      },
    );

    return cms.get().$promise.then((response) => {
      if (response) {
        return response.entries;
      }
    });
  };

  cmsService.getWhitelist = () => {
    var cms = $resource(
      ENV.apiEndpoint + '/1.0/third-party/white-list/',
      {},
      {
        get: {
          headers: { Authorization: 'Bearer ' + Session.accessToken },
        },
      },
    );

    return cms.get().$promise.then((response) => {
      if (response) {
        return response.thirdPartyWhitelists;
      }
    });
  };

  cmsService.createWhiteList = (params) => {
    var whiteList = $resource(
      ENV.apiEndpoint + '/1.0/third-party/white-list/',
      {},
      {
        save: {
          method: 'POST',
          headers: { Authorization: 'Bearer ' + Session.accessToken },
        },
      },
    );

    return whiteList.save(params).$promise.then((response) => {
      return response;
    });
  };

  cmsService.updateWhiteList = (id, params) => {
    var whiteList = $resource(
      ENV.apiEndpoint + '/1.0/third-party/white-list/' + id + '/',
      {},
      {
        save: {
          method: 'PUT',
          headers: { Authorization: 'Bearer ' + Session.accessToken },
        },
      },
    );

    return whiteList.save(params).$promise.then((response) => {
      return response;
    });
  };

  cmsService.deleteWhiteList = (id, paramObj) => {
    var newDeleteSrv = $resource(
      ENV.apiEndpoint + '/1.0/third-party/white-list/' + id + '/',
      {},
      {
        delete: {
          method: 'DELETE',
          data: paramObj,
          headers: {
            Authorization: 'Bearer ' + Session.accessToken,
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        },
      },
    );

    return newDeleteSrv.delete().$promise.then((response) => {
      return response;
    });
  };

  cmsService.getReportingSalesforceFiles = () => {
    var cms = $resource(
      ENV.apiEndpoint + '/1.0/reporting-database/salesforce-files/',
      {},
      {
        get: {
          headers: { Authorization: 'Bearer ' + Session.accessToken },
        },
      },
    );

    return cms.get().$promise.then((response) => {
      if (response) {
        return response.salesforceReportingFilenameSchemas;
      }
    });
  };

  cmsService.createReportingSalesforceFile = (params) => {
    var cms = $resource(
      ENV.apiEndpoint + '/1.0/reporting-database/salesforce-files/',
      {},
      {
        save: {
          method: 'POST',
          headers: { Authorization: 'Bearer ' + Session.accessToken },
        },
      },
    );

    return cms.save(params).$promise.then((response) => {
      return response;
    });
  };

  cmsService.updateReportingSalesforceFile = (id, params) => {
    var cms = $resource(
      ENV.apiEndpoint + '/1.0/reporting-database/salesforce-files/' + id + '/',
      {},
      {
        save: {
          method: 'PUT',
          headers: { Authorization: 'Bearer ' + Session.accessToken },
        },
      },
    );

    return cms.save(params).$promise.then((response) => {
      return response;
    });
  };

  cmsService.deleteReportingSalesforceFile = (id, paramObj) => {
    var cms = $resource(
      ENV.apiEndpoint + '/1.0/reporting-database/salesforce-files/' + id + '/',
      {},
      {
        delete: {
          method: 'DELETE',
          data: paramObj,
          headers: {
            Authorization: 'Bearer ' + Session.accessToken,
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        },
      },
    );

    return cms.delete().$promise.then((response) => {
      return response;
    });
  };

  return cmsService;
});
